import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const GlobalModalContext = createContext();

export const GlobalModalProvider = ({ children }) => {
  const [modals, setModals] = useState([]);
  const [pages, setPages] = useState([]);
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    async function load() {
      try {
       const res = await axios.get(window.BASE_API_URL+"modalshow");

const baseURL = res.data.image_base_url || "";

const processedModals = (res.data.data || []).map((m) => ({
  ...m,
  fullImage: m.image ? baseURL + m.image : ""
}));

setModals(processedModals);
setPages(res.data.pages || []);

      } catch (err) {
        console.error("Modal API Error", err);
      }
    }
    load();
  }, []);

  // 🔥 Helper: check if 30 minutes passed
  const check30Minutes = (modalId) => {
    const last = localStorage.getItem("modal_last_" + modalId);
    if (!last) return true;

    const diff = Date.now() - Number(last);
    return diff >= 30 * 60 * 1000; // 30 min
  };

  // Save show time
  const setShownTime = (modalId) =>
    localStorage.setItem("modal_last_" + modalId, Date.now().toString());

  const showModal = (modal) => {
    const delay = Number(modal.seconds || 0);

    setTimeout(() => {
      setActiveModal(modal);
      setShownTime(modal.id);
    }, delay * 1000);
  };

  // Decide if modal should show for this page
  const evaluatePageModal = (pageId) => {
    modals.forEach((modal) => {
      const menuList = modal.menu?.split(",") || [];

      if (!menuList.includes(String(pageId))) return;

      // Rule 1: show on every page refresh
      if (modal.time_slot_two == 1) {
        return showModal(modal);
      }

      // Rule 2: show every 30 minutes
      if (modal.time_slot_one == 1) {
        if (check30Minutes(modal.id)) {
          return showModal(modal);
        }
      }
    });
  };

  return (
    <GlobalModalContext.Provider
      value={{
        pages,
        activeModal,
        evaluatePageModal,
        closeModal: () => setActiveModal(null),
      }}
    >
      {children}
    </GlobalModalContext.Provider>
  );
};
